import styled from "styled-components";
import fipayFonts from "../../theme/index";
import { colors } from "../../theme/color";
export const FooterContainer = styled.div`
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;

  .Footer_Div {
    margin: 3rem;
    display: flex;
    @media screen and (max-width: 700px) {
      display: grid;
      margin: 1.5rem;
    }

    /* @media screen and (min-width: 767px) and (max-width: 1024px){
      display: grid;
  
    } */

    .Footer_Logo {
      flex-grow: 1;
      margin-right: 30px;
      display: flex;
      flex-direction: column;
    }
    .Footer_Logo img {
      width: 26.6px;
      height: 72.14px;
      object-fit: contain;
      @media screen and (max-width: 700px) {
        margin: 6% 0.5%;
      }
      @media screen and (min-width: 767px) and (max-width: 1024px) {
        margin: 8% 2%;
      }
    }
    .Footer_Paragraph {
      color: #5e5e5e;
      font-family: GT Walsheim Pro;
      font-weight: normal;
      font-size: 18px;
      line-height: 30.8px;
      letter-spacing: 0.02em;
      margin: 4px;
      max-width: 312px;
      @media screen and (max-width: 700px) {
        margin: 6% 0.5%;
        font-size: 16px;
      }
      @media screen and (min-width: 767px) and (max-width: 1024px) {
        margin: 8% 2%;
      }
    }
    .Footer_Mail {
      color: #5e5e5e;
      margin: 4px;
      font-family: GT Walsheim Pro;
      font-size: 18px;
      font-weight: 400;
      line-height: 32px;
      letter-spacing: 0.02em;

      @media screen and (max-width: 700px) {
        margin: 8% 0%;
        font-size: 16px;
      }
      @media screen and (min-width: 767px) and (max-width: 1024px) {
        margin: 8% 2%;
      }
    }
  }

  @media (min-width: 700px) {
    .Footer_Div {
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;

export const FooterLinkContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
  color: black;
  margin-top: 1%;
  @media screen and (max-width: 700px) {
    display: grid;
    flex-direction: row;
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (min-width: 767px) and (max-width: 1024px) {
    flex-direction: row;
    gap: 70px;
    grid-template-columns: repeat(2, 1fr);
  }
  .Footer_Link_Div2 {
    display: flex;
    flex-direction: column;
    margin: 0 0px;
  }

  .Footer_Link_Title {
    font-family: GT Walsheim Pro;
    font-size: 25px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0.5px;
    text-align: left;
    color: #09005b;
    margin: 0;
    margin-bottom: 10px;
    @media screen and (max-width: 700px) {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.02em;
    }
  }

  .Footer_Links {
    list-style-type: none;
    margin: 4px 0;
    padding: 0;
    font-family: GT Walsheim Pro;
    font-size: 32px;
    font-weight: 10%;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #5e5e5e;
  }
  .Footer_Links a,
  .Footer_Links li {
    text-decoration: none;
    color: ${colors.DARK_GRAY};
  }
  .Footer_Link_Name {
    font-weight: normal;
    line-height: 35px;
    font-size: 16px;
    cursor: pointer;
    transition: color 0.3s ease;
    margin: 0;
    margin-bottom: 10px;

    @media screen and (max-width: 700px) {
      font-size: 12px;
    }
  }
`;

export const FooterSocialMedia = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15%;

  margin-top: 10%;
  @media screen and (max-width: 700px) {
    margin: 10% 0%;
  }
  @media screen and (min-width: 767px) and (max-width: 1024px) {
    margin: 10% 2%;
  }
`;

export const FooterLine = styled.div`
  border: 1px solid #e8eaed;
  width: 100%;
  max-width: 1340px;
  margin: 20px auto;
`;

export const FooterCopyright = styled.div`
  font-family: GT Walsheim Pro;
  text-align: center;
  p {
    color: #5e5e5e;
    font-family: "GT Walsheim Pro", sans-serif;

    font-size: ${fipayFonts.fipayFonts.fontSize.temp1};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body1};
  }
  @media screen and (max-width: 700px) {
    font-size: 10px;
  }
`;
